import { Dictionary } from '@common/types';
import { ILSCloseButton } from '../../components/action-buttons/close-button';

export const getCloseButtonComponent = (dictionary: Dictionary, handleClose: (dictionary: Dictionary) => void) => {
  return <ILSCloseButton dictionary={dictionary} handleClose={handleClose} />;
};
